"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrowserMetaModulesContext = exports.setBrowserMetaModulesContext = exports.useMetaModulesContext = exports.MetaModulesContext = void 0;
const react_1 = require("react");
const initialContextValue = {
    hideCookieConsent: false,
    hideBoosters: false,
};
let browserContext = initialContextValue;
exports.MetaModulesContext = (0, react_1.createContext)(initialContextValue);
function useMetaModulesContext() {
    return (0, react_1.useContext)(exports.MetaModulesContext);
}
exports.useMetaModulesContext = useMetaModulesContext;
function setBrowserMetaModulesContext(ctx) {
    if (!process.browser)
        return;
    browserContext = ctx;
}
exports.setBrowserMetaModulesContext = setBrowserMetaModulesContext;
function getBrowserMetaModulesContext() {
    return browserContext;
}
exports.getBrowserMetaModulesContext = getBrowserMetaModulesContext;
//# sourceMappingURL=MetaModules.context.js.map